import './style.css';

import React, { useState } from 'react';
import { t, useLocalization } from '../../l10n/l10n';
import { useEContext } from '../../EContext';
import { Button, Modal } from '@economic/gaudi';

export default function VismaConnectCongratsDialog() {
    const loadingTexts = useLocalization(textIds);
    const { identity } = useEContext();
    const [show, setShow] = useState(true);

    if (loadingTexts || !identity || !show) {
        return null;
    }

    if (!identity.session.vismaConnectPopups) {
        return null;
    }

    const {
        vismaConnectPopups: { displayCongratsPopup },
    } = identity.session;

    if (!displayCongratsPopup || identity.currentAgreement.showGettingStarted) {
        return null;
    }

    return (
        <Modal visible={show} hideOnClickOutside={false}>
            <div className="vismaconnect-popups vismaconnect-congrats">
                <h1>{t`CONNECT_CONGRATULATIONS_HEADLINE`}</h1>

                <br />

                <div dangerouslySetInnerHTML={{ __html: t`CONNECT_CONGRATULATIONS_TEXTFIELD1` }}></div>

                <br />

                <p>{t`CONNECT_CONGRATULATIONS_TEXTFIELD2`}</p>

                <Button appearance="primary" type="button" onClick={() => setShow(false)}>
                    {t`SHARED_CONFIRM_CLOSEWINDOW`}
                </Button>
            </div>
        </Modal>
    );
}

const textIds = [
    'CONNECT_CONGRATULATIONS_HEADLINE',
    'CONNECT_CONGRATULATIONS_TEXTFIELD1',
    'CONNECT_CONGRATULATIONS_TEXTFIELD2',
    'SHARED_CONFIRM_CLOSEWINDOW',
];
